
import state from './moduleClinicState.js';
import mutations from './moduleClinicMutations.js';
import actions from './moduleClinicActions.js';
import getters from './moduleClinicGetters.js';

export default {
	namespaced: true,
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters,
};
